import React from 'react';
export const WhyItMatters = () => {
  return <div className="w-full bg-gray-100 py-12 WhyItMatters" data-id="element-363">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-364">
        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-365">
          <div className="md:w-1/2" data-id="element-366">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ohaANRKi8ZkifrkQcYmtqm/Image_fx_%286%29.jpg" alt="Dog with dental problems" className="rounded-lg shadow-md w-full" data-id="element-367" />
          </div>
          <div className="md:w-1/2" data-id="element-368">
            <h2 className="text-2xl font-bold text-green-900 mb-4" data-id="element-369">
              Cleaning Your Dog's Teeth: Why It Matters
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-370">
              Starting with the basics, bad breath in dogs isn't just about an
              unpleasant smell. It's often the first sign of an imbalanced gut
              microbiome that's allowing harmful, sulfur-producing bacteria to
              thrive. While many vets will tell you it's just about dental
              hygiene, the truth is that 80% of bad breath originates from
              digestive issues, not just the mouth.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md mb-6" data-id="element-371">
              <div className="flex items-center justify-between mb-4" data-id="element-372">
                <span className="text-xl font-bold text-green-900" data-id="element-373">80%</span>
                <span className="text-sm text-gray-500" data-id="element-374">
                  of bad breath originates from digestive issues
                </span>
              </div>
              <div className="w-full bg-gray-200 h-4 rounded-full overflow-hidden" data-id="element-375">
                <div className="bg-amber-600 h-full rounded-full" style={{
                width: '80%'
              }} data-id="element-376"></div>
              </div>
            </div>
            <p className="text-gray-700 mb-6" data-id="element-377">
              When your dog's gut is overrun with the wrong bacteria, these
              microbes produce foul-smelling compounds that travel up through
              the digestive system and out through their breath. The problem?
              Most owners focus only on the symptom (the smell) rather than the
              root cause (the gut imbalance).
            </p>
            <button className="bg-amber-600 text-white font-semibold py-3 px-6 rounded-full hover:bg-amber-500 transition" onClick={() => {
            document.querySelector('.Solution')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-378">
              Get The Solution
            </button>
          </div>
        </div>
      </div>
    </div>;
};